module.exports = __webpack_public_path__ + "static/trinitylogo-d4803d39862752796566344483abcc1b.png";